import { render, staticRenderFns } from "./PartnerExtraAddressForm.vue?vue&type=template&id=131ef305&"
import script from "./PartnerExtraAddressForm.vue?vue&type=script&lang=js&"
export * from "./PartnerExtraAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports